import { render } from "./ScreenChartElement.vue?vue&type=template&id=6d01b698&scoped=true&ts=true"
import script from "./ScreenChartElement.vue?vue&type=script&lang=ts"
export * from "./ScreenChartElement.vue?vue&type=script&lang=ts"

import "./ScreenChartElement.vue?vue&type=style&index=0&id=6d01b698&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d01b698"]])

export default __exports__